import React, { useState, useContext, useEffect, useRef } from "react";
import { Navbar, Container, Button, Form, Row, Col } from "react-bootstrap";
import LoginModal from "../Login/LoginModal";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ContextApp from "./../../../core/contexts/context.app";
import _ from "lodash";
import AdvancedMenu from "./AdvancedMenu";
import SearchModal from "./SearchModal";
import SelectCityModal from "./SelectCityModal";
import {
  IconSearch,
  IconChevronDown,
  IconHome,
  IconCategory,
  IconCall,
  IconWeather,
  Iconboat,
  IconUser,
  IconBasket,
  IconLocation,
  IconUserCheck,
  IconPackage,
} from "./../../../assets/icons";
import logoImg from "./../../../assets/images/logo-s1.png";
import { isMobile } from "react-device-detect";
import ServiceStorage from "../../../core/services/service.storage";
import ApiHome from "../../../core/api/api.home";

function HeaderNav() {
  let location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const ctx = useContext(ContextApp);
  const [countBasketItem, setCountBasketItem] = useState(0);
  const [SearchBox, setSearchBox] = useState(false);
  const [searchText, setSearchText] = useState([]);
  const [showAdvancedMenu, setShowAdvancedMenu] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showModalSelectCity, setShowModalSelectCity] = useState(false);
  const [regions, setRegions] = useState([]);
  const [scrolling, setScrolling] = useState(false);

  const [urlAddress, setUrlAddress] = useState();
  const [liveData, setLiveData] = useState();
  const ref = useRef("");
  useEffect(() => {
    (async () => {
      const data = await ApiHome.getSearchHeaderInfo({
        city: ctx.selectedCity.id,
      });
      setLiveData(data);
    })();
  }, [ctx.selectedCity.id]);
  // ---جهت بستن مدال در مواقعی که هر جای صفحه کلیک شد -----------------y-

  useEffect(() => {
    (async () => {
      //---------------- ذخیره در استوریج --------------------
      const storageCity = ServiceStorage.getCity();
      if (
        !_.isNil(storageCity) &&
        _.has(
          storageCity,
          "selectedCity" && _.isObject(storageCity.selectedCity)
        )
      ) {
        ServiceStorage.setSelectedCity(ctx.selectedCity);
      }
      //-------------------------------------------------------
    })();
  }, [ctx.selectedCity]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        SearchBox && setSearchBox(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [SearchBox]);
  // -----------------------------------------------------------------------y-

  useEffect(() => {
    if (
      !_.isEmpty(ctx.basketInfo) &&
      !_.isEmpty(ctx.basketInfo.basketItemTemps) &&
      ctx.basketInfo.basketItemTemps.length > 0
    )
      setCountBasketItem(
        ctx.basketInfo.basketItemTemps.filter((e) => e.isDeleted === false)
          .length
      );
    else setCountBasketItem(0);
  }, [ctx.basketInfo]); //, ctx.isAuth, ctx.userInfo

  //when user searched and went to another page,search box close and clear
  useEffect(() => {
    setUrlAddress(location.pathname);
    if (location.pathname != "/search" && urlAddress === "/search") {
      setSearchBox(false);
      setSearchText("");
    }
  }, [location.pathname]);

  function callBack() {
    if (ctx.isAuth) {
      navigate("/profile");
    } else {
      navigate("/login");
    }
  }

  const callBackWallet = () => {
    if (ctx.isAuth) {
      navigate("/wallet");
    }
  };
  const advancedMenu = () => {
    setShowAdvancedMenu(true);
    window.scrollTo(0, 0);
  };
  const searchModalMobile = () => {
    setShowSearchModal(true);
  };
  const searchModalDesktop = () => {
    navigate("/search", { state: { searchText: searchText } });
  };
  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      navigate("/search", { state: { searchText: searchText } });
    }
  };
  useEffect(() => {
    ServiceStorage.checkRemovalV2();
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {showModalSelectCity && (
        <SelectCityModal
          showModalSelectCity={showModalSelectCity}
          setShowModalSelectCity={setShowModalSelectCity}
        />
      )}
      {/* {show && <LoginModal show={show} handleClose={handleClose} />} */}
      {showSearchModal && (
        <SearchModal
          data={liveData.data}
          showSearchModal={showSearchModal}
          setShowSearchModal={setShowSearchModal}
        />
      )}
      {isMobile ? (
        <>
          {/************ حالت موبایل ***********************************/}
          <header>
            <Navbar
              expand="lg"
              className="bg-white py-1 justify-content-between shadow-sm"
              fixed="top"
            >
              <Row
                className="w-100 justify-content-between mx-auto
              "
              >
                <Col xs="auto" className="ps-1 pe-0 my-auto">
                  <div
                    className="d-flex
                  "
                  >
                    <Navbar.Toggle
                      aria-controls="navbar-main"
                      className="py-0 px-1 border-0"
                      onClick={advancedMenu}
                    />
                    <Navbar.Brand href="/" className="me-0">
                      <img
                        src={logoImg + "?width=90"}
                        alt="logo"
                        height={35}
                        className="ms-0"
                      />
                    </Navbar.Brand>
                  </div>
                </Col>
                <Col
                  xs="auto"
                  className=" align-items-center my-auto text-end px-0"
                ></Col>
                <Col
                  xs="auto"
                  className=" align-items-center my-auto text-end ps-0"
                >
                  <div className="d-flex align-items-center justify-content-end w-100">
                    <Button
                      className="rounded-pill py-1 ps-2 pe-1 d-flex small-svg"
                      variant="light"
                      onClick={() => {
                        setShowModalSelectCity(true);
                      }}
                    >
                      <IconLocation fillColor="#444" />
                      <span className=" text-truncate-1-line me-1 fs-075">
                        {ctx.selectedCity.name}
                      </span>
                      <IconChevronDown fillColor="#444" />
                    </Button>
                    <Button
                      className="rounded-pill  small-svg px-2 ms-1"
                      variant="light"
                      style={{
                        width: "43px",
                        paddingTop: "1px",
                        paddingBottom: "1px",
                      }}
                      onClick={searchModalMobile}
                    >
                      <IconSearch fillColor="#000" />
                    </Button>
                  </div>
                </Col>
              </Row>

              {showAdvancedMenu && (
                <AdvancedMenu
                  showAdvancedMenu={showAdvancedMenu}
                  setShowAdvancedMenu={setShowAdvancedMenu}
                  isLogin={ctx.isAuth}
                />
              )}
            </Navbar>
          </header>
        </>
      ) : (
        <>
          {/************ حالت دسکتاپ ***********************************/}

          <Navbar
            fixed="top"
            expand="md"
            className={` fs-09 ${scrolling ? " navbar-scrolling" : ""}`}
          >
            <Container className="px-0">
              <div className="d-flex justify-content-between w-100 align-items-center">
                <div className="nav-links">
                  <Link
                    className="mx-0 me-xl-2 text-secondary d-inline-block"
                    onClick={handleClose}
                    to="/"
                  >
                    <img
                      src={logoImg + "?width=90"}
                      alt="logo"
                      height={45}
                      className="ms-2"
                    />
                  </Link>
                  <Link
                    className="mx-2 mx-xl-2 text-primary d-inline-block"
                    onClick={handleClose}
                    to="/"
                  >
                    <span className="d-none d-lg-inline">
                      <IconHome fillColor="#11256A" />
                    </span>
                    صفحه اصلی
                  </Link>
                  <Link
                    className="mx-2 mx-xl-2 text-primary d-inline-block"
                    onClick={handleClose}
                    to={
                      ctx.selectedCity?.englishName == undefined
                        ? "/c"
                        : `/c/${ctx.selectedCity?.englishName}`
                    }
                  >
                    <span className="d-none d-lg-inline">
                      <IconCategory fillColor="#11256A" />
                    </span>
                    لیست تفریحات{" "}
                  </Link>
                  {/* <Link
                    className="mx-2 mx-xl-2 text-primary d-inline-block"
                    onClick={handleClose}
                    to="/g"
                  >
                    <span className="d-none d-lg-inline">
                      <IconPackage fillColor="#11256A" />
                    </span>
                    لیست پکیج ها{" "}
                  </Link> */}
                  {ctx.isAuth && (
                    <Link
                      className="mx-2 mx-xl-2 text-primary d-none d-xl-inline-block"
                      onClick={handleClose}
                      to="/profile"
                    >
                      <span className="d-none d-lg-inline">
                        <IconUserCheck fillColor="#11256A" />
                      </span>
                      پروفایل{" "}
                    </Link>
                  )}
                  <Link
                    className="mx-2 mx-xl-2 text-primary d-inline-block"
                    onClick={handleClose}
                    to="contact"
                  >
                    <span className="d-none d-lg-inline">
                      <IconCall fillColor="#11256A" />
                    </span>
                    تماس با ما
                  </Link>
                  {/* <Link className="mx-3 " onClick={handleClose} to="/">
              <IconWeather fillColor="#000" />
              آب و هوای کیش
            </Link> */}
                  {/* <Link className="mx-3 " onClick={handleClose} to="/">
                <Iconboat fillColor="#000" />
                اطلاعات حرکت شناورها از بندر چارک
              </Link> */}
                </div>
                <div>
                  <div className="d-flex align-items-center">
                    <div className="d-flex bg-light-blue rounded-3 align-items-center py-1 px-2">
                      <button
                        className="btn-no-style d-flex align-items-center"
                        onClick={() => {
                          setShowModalSelectCity(true);
                        }}
                      >
                        <span className="small-svg-1">
                          <IconLocation fillColor="#11256A" />
                        </span>
                        <span className="fs-085 text-primary white-space-nowrap">
                          {ctx.selectedCity?.name != undefined
                            ? ctx.selectedCity?.name
                            : ctx.selectedCity}
                        </span>
                        <span className="small-svg-1">
                          <IconChevronDown fillColor="#11256A" />
                        </span>
                      </button>
                      <Form.Control
                        autoFocus
                        className="search-input border-0 my-0 py-1
                        input-no-style bg-transparent form-control text-primary fs-09 ps-0"
                        type="text"
                        placeholder="جستجو  ..."
                        style={{ width: "120px" }}
                        onKeyDown={handleEnterKey}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                      <span
                        className="search-icon"
                        onClick={searchModalDesktop}
                      >
                        <IconSearch fillColor="#11256A" />
                      </span>
                    </div>
                    {ctx.isAuth ? (
                      <div
                        className="border rounded-3 px-2 py-2 mx-2 cursor-pointer d-flex align-items-center"
                        onClick={callBack}
                      >
                        <IconUserCheck fillColor="#09a463" />{" "}
                        <span className="text-secondary d-none d-lg-inline-block profile-name">
                          {ctx.userInfo?.name}
                        </span>
                      </div>
                    ) : (
                      <div
                        className=" bg-light-blue rounded-3 icon-circle-bg px-2 py-2 mx-2 cursor-pointer"
                        onClick={callBack}
                      >
                        <IconUser fillColor="#11256A" />
                      </div>
                    )}
                    <Link
                      to="/basket"
                      className="bg-danger rounded-3 icon-circle-bg position-relative"
                    >
                      {countBasketItem > 0 && (
                        <span
                          className="position-absolute text-center rounded-pill count-basket fs-085 d-felx align-items-center justify-content-center fw-bold"
                          style={{ zIndex: "1" }}
                        >
                          {countBasketItem}
                        </span>
                      )}
                      <IconBasket fillColor="#ffffff" />
                    </Link>
                  </div>
                </div>
              </div>
            </Container>
          </Navbar>
        </>
      )}
    </>
  );
}

export default HeaderNav;
